var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-picker-option" },
    [
      _c("div", {
        staticClass: "calendar-picker-option__color-indicator",
        style: { backgroundColor: _vm.color }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("\n\t\t" + _vm._s(_vm.displayName) + "\n\t")]),
      _vm._v(" "),
      _vm.isSharedWithMe
        ? _c("Avatar", {
            staticClass: "calendar-picker-option__avatar",
            attrs: {
              "disable-menu": true,
              "disable-tooltip": true,
              user: _vm.userId,
              "display-name": _vm.userDisplayName,
              size: 18
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }